export const LOAD_RECENT_BLOG_POSTS_ACTION_TYPE = 'LOAD_RECENT_BLOG_POSTS_ACTION_TYPE'
export const LOAD_RECENT_BLOG_POSTS_SUCCEEDED_ACTION_TYPE = 'LOAD_RECENT_BLOG_POSTS_SUCCEEDED_ACTION_TYPE'
export const LOAD_RECENT_BLOG_POSTS_FAILED_ACTION_TYPE = 'LOAD_RECENT_BLOG_POSTS_FAILED_ACTION_TYPE'

export const MAX_BLOG_POSTS = 5;

export interface IBlogPostType {
    title: string,
    bodyHtml: string,
    createdDate: string,
}

export interface ILoadRecentBlogPostsSucceededAction {
    type: typeof LOAD_RECENT_BLOG_POSTS_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IBlogPostType>,
    }
}

// Loads the recent blog posts from the server.
export const createLoadRecentBlogPostsAction = () => {
    return {
        type: LOAD_RECENT_BLOG_POSTS_ACTION_TYPE,
    }
};